import React, {useEffect} from "react";
import TextInput from "../../elements/TextInput";
import {isEmpty} from "weed-js";
import {Autocomplete} from "@mui/material";


export const CreateAnOrganization = ({formState, setFormState, errors, setErrors, loggedInUser, userProfile, organizations}) => {
    const [organizationName, setOrganizationName] = React.useState(formState.organization_name || "");
    const nothingToSave = isEmpty(loggedInUser) || isEmpty(userProfile);

    const baseOrganizationOptions = (organizations || []).map(org => ({label: org.name, value: org.id}));
    const organizationOptions = (() => {
        const name = (organizationName || "").trim();
        if (!name) {
            return baseOrganizationOptions;
        }
        const exists = baseOrganizationOptions.find(org => org.label.toLowerCase() === name.toLowerCase());
        if (exists) {
            return baseOrganizationOptions;
        }
        return [{label: name, value: null}, ...baseOrganizationOptions];
    })();

    const errorMessage = errors.organization_id || errors.name || errors.organization_name;

    return <div className={"create-account-create-organization-container"} id={"create-account-create-organization-container"}>
        <h2>Choose or Create an Organization</h2>
        <div className={"create-account-create-organization"}>
            <label htmlFor={"category"}>Organization Name</label>
            {errorMessage ? <p style={{color: "red"}}>{errors.organization_id || errors.name}</p> : null}
            <Autocomplete
                className={"create-organization-dropdown"}
                filterSelectedOptions={false}
                filterOptions={(options, state) => options}
                inputValue={organizationName}
                id={"choose-organization-dropdown"}
                name={"choose-organization-dropdown"}
                role={"choose-organization-dropdown"}
                options={organizationOptions}
                disablePortal={true}
                disabled={nothingToSave}
                isOptionEqualToValue={(option, value) => {
                    if (option?.value !== null && value?.value !== null) return option.value === value.value;
                    return (option?.label ?? "") === (value?.label ?? "");
                }}
                onChange={(event, option) => {
                    if (!option) {
                        return;
                    }
                    console.log("Setting organization name to ", option.label, " with id ", option.value);
                    if (organizationName !== option.label) {
                        setOrganizationName(option.label);
                    }
                    if (!formState.organization_id && option.value !== null) {
                        console.log("Setting organization id to ", option.value || null);
                        setFormState(fs => ({
                            ...fs,
                            organization_id: option.value || null,
                            organization_name: option.value === null ? organizationName : option.label
                        }));
                    } else if (formState.organization_id !== option.value && formState.organization_name !== option.label) {
                        console.log("Setting organization id to ", option.value || null);
                        setFormState(fs => ({
                            ...fs,
                            organization_id: option.value || null,
                            organization_name: option.value === null ? organizationName : option.label
                        }));
                    }
                    setErrors(prev => ({ ...prev,
                        organization_id: undefined,
                        organization_name: undefined
                    }));
                }}
                onInputChange={(event, newInputValue, reason) => {

                    if (reason === "reset") {  // This happens when the UI loads
                        // if (formState.organization_name !== organizationName || formState.organization_id !== null) {
                        //     console.log("Resetting organization_name to ", organizationName, " and organization_id to null. Event:", event);
                        //     setFormState(fs => ({...fs, organization_name: organizationName, organization_id: null}));
                        // }
                    } else if (reason === "input" || reason === "clear") {
                        console.log("Setting organization name to ", newInputValue, " due to reason ", reason);
                        if (organizationName !== newInputValue) {
                            setOrganizationName(newInputValue || "");
                        }
                        // As soon as we’re typing, this is a "new" option => id=null
                        if (formState.organization_name !== newInputValue || formState.organization_id !== null) {
                            console.log("Setting organization_name to ", newInputValue, " and organization_id to null");
                            setFormState(fs => ({...fs, organization_name: newInputValue, organization_id: null}));
                        }
                        // Clear any stale error for organization_id
                        setErrors(prev => ({ ...prev, organization_name: undefined, organization_id: undefined}));
                    }
                }}
                getOptionLabel={(option) => {
                    if (typeof option === "string") {
                        return option;
                    }
                    return option?.label ?? "";
                }}
                renderOption={(props, option) => (
                    <li {...props} key={`choose-organization-${option.value ?? `new-${option.label}`}`}>
                        {option.value == null && option.label?.trim()
                            ? `Create “${option.label.trim()}”`
                            : option.label}
                    </li>
                )}
                renderInput={(params) => (
                    <TextInput
                        {...params}
                        name="organization"
                        label="Organization"
                        id={"choose-organization-dropdown-input"}
                        formState={formState}
                        setFormState={setFormState}
                        value={organizationName}
                        errors={errors}
                        setErrors={setErrors}
                        disabled={nothingToSave}
                        placeholder={"e.g. 'Weed Inc.'"}
                        onBlur={(event) => {
                            console.log("Blur event.", event, "org name: ", organizationName);
                            if (!organizationName.trim()) {
                                setErrors(prev => ({ ...prev, organization_id: "Organization name is required.", organization_name: "Organization name is required."}));
                            } else {
                                setErrors(prev => ({ ...prev, organization_id: undefined, organization_name: undefined}));
                            }
                        }}
                    />
                )}
            />
        </div>
    </div>;
};


export default CreateAnOrganization;
